export enum ChainName {
  ETHEREUM = 'ETHEREUM',
  BASE = 'BASE'
}
